module.exports = __webpack_public_path__ + "static/media/Program4.088dbae9.jpg";